import axiosInstance from "../api/axios";

const E = "/esign";

/* ---------------- Signing vendors (Aadhaar eSign registry) ---------------- */
export const listSigningVendors = (includeInactive = true) =>
  axiosInstance.get(`${E}/vendors${includeInactive ? "?includeInactive=true" : ""}`);
export const getSigningVendor = (id) => axiosInstance.get(`${E}/vendors/${id}`);
export const createSigningVendor = (body) => axiosInstance.post(`${E}/vendors`, body);
export const updateSigningVendor = (id, body) => axiosInstance.put(`${E}/vendors/${id}`, body);
export const deleteSigningVendor = (id) => axiosInstance.delete(`${E}/vendors/${id}`);
